module.exports = __webpack_public_path__ + "img/role.24ade6ec.svg";